var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.308,
    height: 105.308,
    viewBox: "0 0 105.308 105.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ui_ux_icon",
    "data-name": "ui ux icon",
    d: "M44.123,59.919H7.265A5.265,5.265,0,0,0,2,65.185v36.858a5.265,5.265,0,0,0,5.265,5.265H44.123a5.265,5.265,0,0,0,5.265-5.265V65.185A5.265,5.265,0,0,0,44.123,59.919ZM38.858,96.777H12.531V70.45H38.858ZM102.042,2H65.185a5.265,5.265,0,0,0-5.265,5.265V44.123a5.265,5.265,0,0,0,5.265,5.265h36.858a5.265,5.265,0,0,0,5.265-5.265V7.265A5.265,5.265,0,0,0,102.042,2ZM96.777,38.858H70.45V12.531H96.777Zm5.265,21.062H65.185a5.265,5.265,0,0,0-5.265,5.265v36.858a5.265,5.265,0,0,0,5.265,5.265h36.858a5.265,5.265,0,0,0,5.265-5.265V65.185A5.265,5.265,0,0,0,102.042,59.919ZM96.777,96.777H70.45V70.45H96.777ZM44.123,2H7.265A5.265,5.265,0,0,0,2,7.265V44.123a5.265,5.265,0,0,0,5.265,5.265H44.123a5.265,5.265,0,0,0,5.265-5.265V7.265A5.265,5.265,0,0,0,44.123,2ZM38.858,38.858H12.531V12.531H38.858Z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.5db26efed0947cd283e5c4c26b5e9f1e.svg";
export { ForwardRef as ReactComponent };